import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AnimatePresence } from 'framer-motion';
import { LandingPage } from './pages/LandingPage';
import { ConfirmationPage } from './pages/ConfirmationPage';
import { HallOfRagePage } from './pages/HallOfRagePage';
import { NicknamePromptModal } from './components/NicknamePromptModal';
import { getCurrentUser, getDisplayName } from './authService';
import { supabase } from './config/supabaseClient';
const APP_VERSION = '1.0.11';
export function App() {
  const [showNicknamePrompt, setShowNicknamePrompt] = useState(false);
  const [isCheckingUser, setIsCheckingUser] = useState(true);
  useEffect(() => {
    console.log(`🚀 IBD Rant v${APP_VERSION} loaded`);
    console.log('📅 Build timestamp:', new Date().toISOString());
    const checkUserDisplayName = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          const displayName = await getDisplayName(user.id);
          if (!displayName) {
            setShowNicknamePrompt(true);
          }
        }
      } catch (error) {
        console.error('Error checking user display name:', error);
      } finally {
        setIsCheckingUser(false);
      }
    };
    checkUserDisplayName();
    const {
      data: authListener
    } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'SIGNED_IN' && session) {
        const displayName = await getDisplayName(session.user.id);
        if (!displayName) {
          setShowNicknamePrompt(true);
        }
      }
    });
    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);
  return <HelmetProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/confirmation" element={<ConfirmationPage data-id="element-6" />} data-id="element-5" />
          <Route path="/hall-of-rage" element={<HallOfRagePage data-id="element-8" />} data-id="element-7" />
        </Routes>
        <AnimatePresence data-id="element-9">
          {showNicknamePrompt && !isCheckingUser && <NicknamePromptModal onComplete={() => setShowNicknamePrompt(false)} data-id="element-10" />}
        </AnimatePresence>
      </BrowserRouter>
    </HelmetProvider>;
}
export { APP_VERSION };